import { CheckSmallIcon, Chip } from '@zep-us/zus';
import { Violet300 } from '@zep-us/zus/tokens';
import { type QuotePlanFeature } from '../constants/quizQuote.const';
interface FeatureListProps {
  features: QuotePlanFeature[];
}

/** 플랜 기능 리스트 — 2열 그리드, 체크 아이콘 + (선택) AI 칩 (Figma "plan function"). */
export function FeatureList({
  features
}: FeatureListProps) {
  return <div className="grid w-full grid-cols-2 gap-x-xs gap-y-xs rounded-sm bg-white px-lg py-md" data-sentry-component="FeatureList" data-sentry-source-file="FeatureList.tsx">
      {features.map(feature => <div key={feature.label} className="flex items-center gap-2xs">
          <CheckSmallIcon size="md" fill={Violet300} />
          <span className="text-body-md-medium text-default">
            {feature.label}
          </span>
          {feature.isAi ? <Chip size="xs" rounded="full">
              AI
            </Chip> : null}
        </div>)}
    </div>;
}